// Mục "Phễu nhiệm vụ": tổng xong → đã nhận của 3 nhiệm vụ + tỉ lệ làm đủ 3 nhiệm vụ theo ngày.
import { Card, Col, Row } from "antd";
import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import XuEmptyHint from "./xu-empty-hint";
import { shortDate, useXuChart } from "./xu-chart-style";
import { fmtPct, missionKeys, missionName } from "./xu-format-helpers";

export default function XuStatsMissionsSection({ days, funnel, missionTitles = {} }) {
    const KEYS = missionKeys(days, missionTitles);
    const { chart, tooltip } = useXuChart();
    const sums = KEYS.map((k) => ({
        name: missionName(k, missionTitles),
        completed: days.reduce((s, d) => s + d.missions[k]?.completed || 0, 0),
        claimed: days.reduce((s, d) => s + d.missions[k]?.claimed || 0, 0),
    }));
    const any = sums.some((s) => s.completed);
    const totalAny = funnel.reduce((s, d) => s + d.anyDone, 0);
    const totalAll = funnel.reduce((s, d) => s + d.allDone, 0);
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} lg={12}>
                <Card size="small" title="Phễu nhiệm vụ: làm xong → đã nhận Xu" className="shadow-sm h-full">
                    {!any ? <XuEmptyHint title="Chưa có nhiệm vụ nào hoàn thành" hint="Mỗi nhiệm vụ làm xong rồi bấm “Nhận” trong app sẽ hiện ở đây." /> : (
                        <ResponsiveContainer width="100%" height={240}>
                            <BarChart data={sums} layout="vertical" margin={{ left: 20 }}>
                                <CartesianGrid stroke={chart.grid} strokeDasharray="3 3" />
                                <XAxis type="number" stroke={chart.axis} fontSize={12} allowDecimals={false} />
                                <YAxis type="category" dataKey="name" stroke={chart.axis} fontSize={12} width={130} />
                                <Tooltip {...tooltip} />
                                <Legend />
                                <Bar dataKey="completed" name="Làm xong" fill={chart.series[1]} radius={[0, 3, 3, 0]} />
                                <Bar dataKey="claimed" name="Đã nhận Xu" fill={chart.series[2]} radius={[0, 3, 3, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    )}
                </Card>
            </Col>
            <Col xs={24} lg={12}>
                <Card size="small" className="shadow-sm h-full"
                    title={<span>Tỉ lệ làm đủ nhiệm vụ <span className="text-xs font-normal text-gray-400">· cả khoảng: {fmtPct(totalAny ? Math.round((totalAll / totalAny) * 1000) / 10 : null)}</span></span>}>
                    {!totalAny ? <XuEmptyHint title="Chưa có ai làm nhiệm vụ" hint="Tỉ lệ = số người làm đủ mọi nhiệm vụ đang bật / số người làm ít nhất 1 nhiệm vụ trong ngày." /> : (
                        <ResponsiveContainer width="100%" height={240}>
                            <LineChart data={funnel.map((d) => ({ ...d, label: shortDate(d.vnDate), allPct: d.allPct ?? 0 }))}>
                                <CartesianGrid stroke={chart.grid} strokeDasharray="3 3" />
                                <XAxis dataKey="label" stroke={chart.axis} fontSize={12} />
                                <YAxis stroke={chart.axis} fontSize={12} unit="%" domain={[0, 100]} />
                                <Tooltip {...tooltip} formatter={(v) => `${v}%`} />
                                <Line type="monotone" dataKey="allPct" name="Làm đủ NV" stroke={chart.series[4]} strokeWidth={2} dot={false} />
                            </LineChart>
                        </ResponsiveContainer>
                    )}
                </Card>
            </Col>
        </Row>
    );
}
